import React from 'react';

const SentactFeedbackStamp = ({}) => {
    return <div className={`w-full text-center color1-text hover:underline powered-by-stamp`}>
        Powered by <b><a href={`https://www.sentact.com`}>SentactFeedback</a></b>
    </div>;
};

export default SentactFeedbackStamp;
